import { getTenantById } from '@tenants/manager';
import { getTenantSeoConfig } from '@tenants/utils/configs';
import type { TenantId } from '@tenants/types';

/**
 * Determines if inLanguage should be added to schemas based on tenant SEO config
 * 
 * @param tenantId - The tenant identifier
 * @param locale - The current locale (e.g., 'en-CA', 'fr-CA')
 * @returns The locale to use for schemas, or undefined if inLanguage should not be added
 * 
 * @example
 * ```typescript
 * const localeForSchema = resolveSchemaLocale(tenant.id, currentLocale);
 * const schema = new SchemaBuilder()
 *   .setType('Product')
 *   .setInLanguage(localeForSchema)
 *   .build();
 * ```
 */
export function resolveSchemaLocale(tenantId: TenantId, locale: string): string | undefined {
  const tenant = getTenantById(tenantId);
  const seoConfig = getTenantSeoConfig(tenant);
  const shouldAddInLanguage = seoConfig?.includeInLanguageInSchemas ?? false;
  
  return shouldAddInLanguage ? locale : undefined;
}
